import React, { FC, useContext, useEffect, useState } from "react";
import { AppShell as MantineAppShell, useMantineTheme } from "@mantine/core";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import { AppContext } from "src/api/AppContext";
import { useElementSize } from "@mantine/hooks";

interface Props {
  children: React.ReactNode;
}

const ClientAppShell: FC<Props> = ({ children }) => {
  const theme = useMantineTheme();
  const { isDarkMode, setWorkspaceDimensions } = useContext(AppContext);
  const [isNavbarOpen, setNavbarOpened] = useState<boolean>(false);
  const { ref, width, height } = useElementSize();
  const navbarOffsetBreakpoint = "md";

  useEffect(() => {
    setWorkspaceDimensions({ width, height });
  }, [width, height, setWorkspaceDimensions]);

  return (
    <MantineAppShell
      fixed
      navbarOffsetBreakpoint={navbarOffsetBreakpoint}
      styles={(theme) => ({
        main: {
          backgroundColor: theme.colors.secondary[6],
          // isDarkMode
          //   ? theme.colors.gray[8]
          //   : theme.colors.light[0],
          color: isDarkMode ? theme.colors.light[1] : theme.black,
        },
      })}
      header={
        <Header
          isNavbarOpen={isNavbarOpen}
          setNavbarOpened={setNavbarOpened}
          navbarOffsetBreakpoint={navbarOffsetBreakpoint}
        />
      }
      navbar={
        <>
          <Navbar isOpened={isNavbarOpen} setNavbarOpened={setNavbarOpened} />
        </>
      }
    >
      <div
        ref={ref}
        style={{
          overflowY: "auto",
          height:
            "calc((100vh - (var(--mantine-header-height, 0px) + var(--mantine-footer-height, 0px) + 32px )) )",
        }}
      >
        {children}
      </div>
    </MantineAppShell>
  );
};

export default ClientAppShell;

interface Props {
  children: React.ReactNode;
}
